import axios from 'axios';

export function getEvents() {
    return axios.get(`${process.env.REACT_APP_SISAPI}/v1/acropolis/events`);
}
